import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AdminGuard } from './admin.guard';
import { AuthGuard } from './guards/auth.guard';

// TODO AuthGuards on appropriate pages
const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'resetpassword',
    loadChildren: () => import('./pages/reset-password/reset-password.module').then(m => m.ResetPasswordPageModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./pages/account/account.module').then(m => m.AccountPageModule),
  },
  {
    path: 'options',
    loadChildren: () => import('./pages/options/options.module').then(m => m.OptionsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'mainlines',
    loadChildren: () => import('./pages/mainline/mainline.module').then(m => m.MainlinePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'laterals',
    loadChildren: () => import('./pages/lateral/lateral.module').then(m => m.LateralPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'custom-pipe-sizes',
    loadChildren: () => import('./pages/custom-pipe-size/custom-pipe-size.module').then(m => m.CustomPipeSizePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'formulas',
    loadChildren: () => import('./pages/common-formulas/common-formulas.module').then(m => m.CommonFormulasPageModule)
  },
  {
    path: 'help',
    loadChildren: () => import('./pages/help/help.module').then(m => m.HelpPageModule),
  },
  {
    path: 'payback',
    loadChildren: () => import('./pages/payback/payback.module').then(m => m.PaybackPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'admin',
    canActivate: [AuthGuard, AdminGuard],
    loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminPageModule)
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
